import useShow from '../../../../../hooks/shows/useShowFromURL';
import AboutPanel from '../AboutPanel';
import styles from './styles.module.scss';
import Gradient, { GRADIENT_POSITION_BOTTOM } from '@/components/app/Gradient';
import { classes } from '@/helpers/styling';

const GRADIENT_BOTTOM_STYLE = { height: '5px' };

const AboutSection = () => {
  const {
    isLoading,
    show
  } = useShow();

  const {
    hosts,
    network,
    origin,
    external_links: links,
    release_date,
    format,
    genres
  } = show;

  const releaseYear = new Date(release_date).getFullYear();

  return (
    <div className={ styles.about }>
      <div className={ classes(styles.aboutContent, { [styles.isLoading]: isLoading }) }>
        <AboutPanel
          format={ format }
          genres={ genres }
          hosts={ hosts }
          links={ links }
          loading={ isLoading }
          network={ network ? network.title : null }
          origin={ origin }
          releaseYear={ releaseYear }
        />
        <Gradient
          directionReverse
          gradientBreadth='75%'
          position={ GRADIENT_POSITION_BOTTOM }
          style={ GRADIENT_BOTTOM_STYLE }
        />
      </div>
    </div>
  );
};

export default AboutSection;